import React, { useContext } from 'react';
import { Context } from '../Context/Context';
import { Link, useNavigate } from 'react-router-dom';
import './CSS/Cart.css';
const Cart = () => {
  const { all_products, cartItems, addToCart, removeFromCart } = useContext(Context);
  const navigate = useNavigate();

  let totalCost = 0;
  const cartEntries = Object.entries(cartItems || {}).filter(([key, qty]) => qty > 0);

  return (
    <div className='cart'>
      <h1>Your Cart</h1>
      {cartEntries.length === 0 ? (
        <p>your cart is empty :( </p>
      ) : (
        <div className='cart-items-container'>
          {cartEntries.map(([key, qty]) => {
            const [idStr, size] = key.split('_');
            const id = Number(idStr);
            const product = all_products.find((p) => p.id === id);
            
            if (!product) return null;

            const printPrice = product.price[size];
            const numericalPrice = Number(printPrice.replace('$', ''));
            const cost = numericalPrice * qty;
            totalCost += cost;

            return (
              <div className='cart-item' key={key}>
                <div className='cart-item-img-wrapper'>
                  <img src={product.image} alt="" className='cart-item-img' />
                </div>
                <div className='cart-item-details'>
                  <h3>{product.name}</h3>
                  <p>Size: {size}</p>
                  <p>Price: {printPrice}</p>
                </div>
                <div className='cart-item-actions'>
                  <div className='cart-item-qty'>
                    <button onClick={() => removeFromCart(id, size)}>-</button>
                    <span>{qty}</span>
                    <button onClick={() => addToCart(id, size)}>+</button>
                  </div>
                  <div className='cart-item-total'>
                    <p>${cost.toFixed(2)}</p>
                  </div>
                </div>
              </div>
            );
          })}
          
          <div className='cart-summary'>
            <h2>Total: ${totalCost.toFixed(2)}</h2>
            <button className='checkout-btn' onClick={() => navigate('/checkout')}>Check out</button>
          </div>
        </div>
      )}
    </div>
  );
};

export default Cart;
